// src/AuthClient.ts
var errorKey = "error_code";
var errorLogPrefix = "[AuthClient] ";
var Provider = /* @__PURE__ */ ((Provider2) => {
  Provider2["GOOGLE"] = "google";
  return Provider2;
})(Provider || {});
function isSessionReturn(result) {
  return result.type === "session";
}
function isSuccessReturn(result) {
  return result.type === "success";
}
function isErrorReturn(result) {
  return result.type === "error";
}
var AuthClient = class {
  constructor(baseUrl, options) {
    this.error = null;
    this.baseUrl = baseUrl;
    this.options = options;
    this.parseRedirectError();
  }
  hasError() {
    return !!this.error;
  }
  getError() {
    return this.error;
  }
  clearError() {
    this.error = null;
  }
  signInWithProvider(provider) {
    window.location.href = `${this.baseUrl}/auth/${provider}/sign-in`;
  }
  signUpWithProvider(provider) {
    window.location.href = `${this.baseUrl}/auth/${provider}/sign-up`;
  }
  signOut() {
    window.location.href = `${this.baseUrl}/auth/sign-out`;
  }
  check() {
    return this.request(`/check`, void 0, true);
  }
  switchOrg(orgSlug) {
    return this.request(`/switch-org?new_org_slug=${orgSlug}`);
  }
  verifyCode(code) {
    return this.request(`/verify-email?verification_code=${code}`);
  }
  resetPassword(email) {
    return this.request(`/reset-password?email=${email}`);
  }
  changePassword(props) {
    return this.request("/change-password", props);
  }
  signIn(props) {
    return this.request("/admin/sign-in", props);
  }
  signUp(props) {
    return this.request("/admin/sign-up", props);
  }
  parseRedirectError() {
    const search = new URLSearchParams(location.search);
    for (const [key, value] of search.entries()) {
      if (key === errorKey) {
        this.updateError(value, false);
      }
    }
  }
  updateError(errorCode, skipError) {
    if (!skipError) {
      this.error = { errorCode };
    }
  }
  async request(path, body, dontUpdateError = false) {
    if (!dontUpdateError) this.clearError();
    let config = {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      },
      credentials: "include"
    };
    if (body) {
      const csrfToken = await this.options.getCsrfToken();
      if (!csrfToken) {
        throw new Error(
          `${errorLogPrefix}A csrf Token has to be set for POST requests!`
        );
      }
      config = {
        ...config,
        method: "POST",
        headers: {
          ...config.headers,
          "x-csrf-token": csrfToken
        },
        body: JSON.stringify(body)
      };
    }
    return fetch(`${this.baseUrl}/auth${path}`, config).catch(() => {
      throw { error_code: "network_error" };
    }).then((response) => {
      if (!response.ok) {
        throw new Error(
          `${errorLogPrefix}Response had the status ${response.status}: ${JSON.stringify(response)}`
        );
      }
      return response.json();
    }).then((response) => {
      if (response.status === "error" /* ERROR */) {
        if (response.error_code) {
          this.updateError(response.error_code, dontUpdateError);
          return {
            type: "error",
            errorCode: response.error_code
          };
        }
      }
      if (response.status === "success" /* SUCCESS */) {
        if (response.session) {
          return {
            type: "session",
            session: {
              userId: response.session.user_id,
              currentOrgId: response.session.current_org_id,
              permissions: response.session.permissions
            }
          };
        }
        return {
          type: "success",
          returnTo: response.return_to
        };
      }
      throw `Response was neither success nor error: ${JSON.stringify(response)}`;
    }).catch((error) => {
      if (error.error_code) {
        this.updateError(error.error_code, dontUpdateError);
      } else {
        console.error(`${errorLogPrefix}Unexpected error ${error}`);
        this.updateError("unknown", dontUpdateError);
      }
      throw false;
    });
  }
};
export {
  AuthClient,
  Provider,
  isErrorReturn,
  isSessionReturn,
  isSuccessReturn
};
//# sourceMappingURL=index.js.map